import React from 'react'

const Header = () => {
  return (
    <div className="App-header">REACT INTERVIEW QUESTIONS AND ANSWERS</div>
  )
}

export default Header